<template>
	<transition name="toast-in-out">
		<div class="nio-toast flexBox" v-if="callToast">
			<span class="tips" v-html="toastText"></span>
		</div>
	</transition>
</template>

<script>
	export default {
		name: 'toast',
        computed: {
            callToast(){
                return this.$store.getters.GET_CallToast
            },
            toastText(){
                return this.$store.getters.GET_ToastText
            }
        }
	}
</script>

<style lang="scss" scoped>
	.nio-toast {
		position: fixed;
		top: 0; bottom: 0;
		left: 0; right: 0;
		justify-content: center;
		z-index: 99999;
		padding:j(50);
		.tips {
			color: #ffffff;
			text-align: center;
			min-width: j(150);
			font-size: j(32);
			padding:j(18) j(30);
			background:rgba(4, 11, 41, .8);
			border-radius: j(4);
			word-break: break-word;
		}
	}
	.toast-in-out-enter-active,.toast-in-out-leave-active {
		transition: all .5s linear;
	}
	.toast-in-out-enter,.toast-in-out-leave-to{
		opacity: 0;
	}
</style>



// WEBPACK FOOTER //
// src/components/toast.vue